/** @jsxImportSource @emotion/react */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Image } from 'semantic-ui-react';
import { OauthSenderButton } from '../components/OauthSenderButton';
import { OAUTH_AUTHORIZE_URL, OAUTH_CLIENT_ID, REDIRECT_URI } from '../../../constants';
import keringLogo from '../../../assets/keringLogo_scritta.png';
import style from './login.style';

export const Login = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card fluid css={style.card}>
      <Card.Content css={style.cardContent}>
        <div css={style.contentContainer}>
          <Image src={keringLogo} wrapped />
          <h3 css={style.title}>{t('title')}</h3>
          <OauthSenderButton authorizeUrl={OAUTH_AUTHORIZE_URL} clientId={OAUTH_CLIENT_ID} redirectUri={REDIRECT_URI} />
        </div>
      </Card.Content>
    </Card>
  );
};
